// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"7948662e","48":"c94816ad","160":"3ca75222","749":"9abad6b5","800":"5ec3859d","835":"d4c83934","980":"0a9568bf"}[chunkId] + ".chunk.css";
};